<!-- <app-header></app-header>
<section style="margin: 1rem;">
   <router-outlet />
</section> -->


<div>
   <app-banner-container></app-banner-container>
    
   <app-header></app-header>
    
   <section class="sectionMargin">
      <router-outlet />
   </section>
</div>